const FormResources = {

    form_data:{
        room_id:            '',
        description:        '',
        requestor_name:     '',
        requestor_email:    '',
        requestor_phone:    '',
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Room:',
            model_name: 'room_id',
            ref:        'room_id_input',
            ref_alt:    'room_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Requestor name:',
            model_name: 'requestor_name',
            ref:        'requestor_name_input',
            ref_alt:    'requestor_name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'email',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Requestor email:',
            model_name: 'requestor_email',
            ref:        'requestor_email_input',
            ref_alt:    'requestor_email_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Requestor phone:',
            model_name: 'requestor_phone',
            ref:        'requestor_phone_input',
            ref_alt:    'requestor_phone_input_alt',
            required:   true,
        },
    ],

}

export default FormResources;